export enum OptionsBoardColumnsEnum {
	strike = 'strike',
	bid = 'bid',
	ask = 'ask',
	last = 'last',
	change = 'change',
	breakeven = 'breakeven',
	volatility = 'volatility',
	interest = 'interest',
	delta = 'delta',
	gamma = 'gamma',
	theta = 'theta',
	vega = 'vega',
}
